// extracted by mini-css-extract-plugin
export default {"component":"info_component__zosmK","logo":"info_logo__hr8TK","description":"info_description__qz1b6"};